<div class="list-page">
  <app-asiakas-otsikko otsikko="Maksutavat" paluuUrl="/asiakkaat" [asiakas]="asiakas"></app-asiakas-otsikko>

  @if (eiTilikausia) {
    <div style="padding: 20px">Asiakkaalla ei ole yhtään tilikautta. Maksutapoja ei voi muokata.</div>
  }

  @if (!eiTilikausia) {
    <!--
    <div style="display: flex; justify-content: flex-end; flex-flow: row; align-items: center; margin-bottom: 10px;">
      <button mat-button (click)="lisaaKayttaja()" type="button" class="primarybutton mat-elevation-z4">
        <mat-icon>add</mat-icon>
        Lisää käyttäjä
      </button>
    </div> -->
    <div>
      <!-- <div style="position: relative;">
      <mat-table matSort [dataSource]="kayttajatDataSource" [matSortDisableClear]="true" style="min-height: 94px;">
        <ng-container matColumnDef="etunimi">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Etunimi </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{row.etunimi}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="sukunimi">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Sukunimi </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{row.sukunimi ? row.sukunimi : '&nbsp;'}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="email">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Sähköposti </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{row.email ? row.email : '&nbsp;'}} </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="kayttajatNaytettavatKolumnit"></mat-header-row>
        <mat-row (click)="muokkaaKayttajaa(row)" *matRowDef="let row; columns: kayttajatNaytettavatKolumnit"></mat-row>
      </mat-table>
      <div class="table-ladataan" style="position: absolute; top: 0px; width: 100%; height: 100%; display: flex; justify-items: center; align-items: center;" *ngIf="!kayttajatLataa && kayttajatDataSource?.filteredData?.length == 0">
        <div style="width: 100%; padding-top: 40px; text-align: center;">
          Yhtään käyttäjää ei löytynyt.
        </div>
      </div>
      <<div lemon-loading [show]="kayttajatLataa"></div>
    </div> -->
    </div>
    <div style="margin-left: 10px; padding-bottom: 5em">
      <h2 style="margin: 0">Pankkitilit, joihin olemme saaneet katseluoikeuden</h2>
      @if (kirjanpitajaOnDevaajaObservable | async) {
        <div style="padding: 10px; margin-bottom: 20px; margin-left: 20px; max-width: 600px; position: relative" class="mat-elevation-z2">
          <span style="font-size: 10px; position: absolute; top: 3px; right: 5px" class="light-gray-text">(Vain devaajat)</span>
          <h3 style="margin: 0">Urit</h3>
          <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
            Bank Connections (Lemonaid): <a [href]="bankConnectionsEncodedUriObservable | async" target="_BLANK">{{ bankConnectionsUriObservable | async }}</a>
          </div>
        </div>
      }
      @if (lataaIbaneja()) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
      <div [style.hidden]="lataaIbaneja() ? 'hidden' : 'visible'" style="margin-left: 10px">
        @if (asiakkaanIbanitJaPankitObservable | async; as pankitJaIbanit) {
          <table>
            <thead>
              <tr>
                <th>Pankki</th>
                <th>BIC</th>
                <th>IBAN</th>
                <th>Lähde</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              @for (pankkiJaIban of pankitJaIbanit; track pankkiJaIban) {
                <tr>
                  <td [style.text-decoration]="pankkiJaIban.disabledInLemonator ? 'line-through' : 'none'">{{ pankkiJaIban.pankki }}</td>
                  <td [style.text-decoration]="pankkiJaIban.disabledInLemonator ? 'line-through' : 'none'">{{ pankkiJaIban.bic }}</td>
                  <td [style.text-decoration]="pankkiJaIban.disabledInLemonator ? 'line-through' : 'none'">{{ pankkiJaIban.iban }}</td>
                  <td style="text-align: center">{{ pankkiJaIban.source }}</td>
                  <td>
                    @if (pankkiJaIban.disabledInLemonator) {
                      <span style="font-weight: bold">
                        (Tarpeeton tili)
                        <app-secondary-button (click)="enableConnectedAccount(pankkiJaIban)" actionId="Aktivoi (tarpeeton tili) uudelleen"> Aktivoi uudelleen </app-secondary-button>
                      </span>
                    } @else {
                      <app-secondary-button (click)="disableConnectedAccount(pankkiJaIban)" actionId="Merkitse tili tarpeettomaksi"> Merkitse tarpeettomaksi </app-secondary-button>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        } @else {
          <div style="padding: 3em">Yritys ei ole antanut oikeutta katsella yhtään pankkitiliä.</div>
        }
      </div>
    </div>
    <div style="margin-left: 10px; display: flex; justify-content: space-between; flex-flow: row wrap; align-items: center">
      <h2 style="margin: 0">Maksutavat kirjanpidossa</h2>
      <app-secondary-button (click)="lisaaMaksutapa()" actionId="Avattu muokkausnäkymä: Lisää maksutapa rivi" additionalClass="mat-elevation-z4" styles="height: 40px; padding-left: 8px; margin: 0 2em;" matIcon="add"> Lisää maksutapa </app-secondary-button>
    </div>
    <div style="margin-left: 10px">
      <div style="padding: 20px" class="dark-gray-text">Kirjanpidon maksutavat näkyvät Lemonaidissa valituilla käyttäjillä tositteiden toimittamisessa. Näillä maksutavoilla asiakas ei voi hoitaa rahaliikennettä tai maksaa laskuja.</div>
    </div>
    @if (kirjanpitajaOnDevaajaObservable | async) {
      <div style="padding: 10px; margin-bottom: 20px; margin-left: 20px; max-width: 600px; position: relative" class="mat-elevation-z2">
        <span style="font-size: 10px; position: absolute; top: 3px; right: 5px" class="light-gray-text">(Vain devaajat)</span>
        <h3 style="margin: 0">Urit</h3>
        <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
          Maksutavat (Lemonator): <a [href]="maksutavatEncodedUriObservable | async" target="_BLANK">{{ maksutavatUriObservable | async }}</a>
        </div>
        <div style="padding-top: 0em; padding-left: 1em; padding-right: 1em">
          Maksutavat (Lemonaid eu asiakkaassa): <a [href]="maksutavatLemonaidCustomersEncodedUriObservable | async" target="_BLANK">{{ maksutavatLemonaidCustomersUriObservable | async }}</a>
        </div>
        <div style="padding-top: 0.5em; padding-left: 1em; padding-right: 1em">Maksutavat (Lemonaid usa realtime db, käyttäjittäin):</div>
        @for (kayttaja of maksutavatLemonaidRealtimeDbUriObservable | async; track kayttaja) {
          <div style="padding-left: 1em">
            <div style="padding-top: 0em; padding-left: 1em; padding-right: 1em">
              {{ kayttaja.kayttaja }}: <a [href]="kayttaja.encodedUri" target="_BLANK">{{ kayttaja.uri }}</a>
            </div>
          </div>
        }
      </div>
    }
    <div style="margin-top: 10px">
      @if (lataaMaksutapoja) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
      @if (!lataaMaksutapoja) {
        <form novalidate>
          <table style="border-spacing: 0">
            <tr>
              <th></th>
              <th>Kuva</th>
              <!-- <th style="width: 61px;">Tunniste</th> -->
              @if (isHolviUlkopTositteetVisible) {
                <th style="width: 150px">Holvi ulkop. tositteet</th>
              }
              <!-- <th *ngIf="isOmallaRahallaColumnVisible">Kenen rahalla?</th> -->
              <th>Nimi</th>
              <th>Kirjauksien muodostus</th>
              <th>Tilinumero</th>
              <th>Vastakirjaus</th>
              <th>Voimassa alkaen</th>
              <th>Voimassa loppuen</th>
              <th>Käytössä käyttäjillä</th>
              <th style="width: 41px">Aktiivinen</th>
              <th style="width: 41px">Valtuutus?</th>
              <!-- <th style="width: 41px;">Oletus</th>
            <th style="width: 81px;">Järjestys</th> -->
              <th style="width: 41px"></th>
            </tr>
            @for (maksutapa of lomake.maksutavat; track maksutapa; let i = $index) {
              <tr>
                <td>
                  <div class="dark-gray-text" style="font-size: 30px; padding-right: 10px; padding-top: 14px">{{ maksutavatJaKayttajat[i].maksutapa.tunniste }}</div>
                </td>
                <td (click)="lisaaMaksutavanKuva(i)" style="padding-top: 6px; cursor: pointer">
                  <img [src]="'data:image/png;base64,' + maksutavatJaKayttajat[i].maksutapa.base64Kuva" style="width: 40px; border-radius: 40px; vertical-align: middle" class="light-blue-background" />
                </td>
                @if (isHolviUlkopTositteetVisible) {
                  <td>
                    <mat-checkbox
                      [style.visibility]="maksutapa.kirjaustenLuontityyppi().value()?.tunniste === 'g' ? 'visible' : 'hidden'"
                      style="position: relative; top: 15px; left: 20px"
                      (change)="holviOmallaRahallaTiliChanged(maksutavatJaKayttajat[i].maksutapa.tunniste)"
                      [checked]="holviOmallaRahallaTili === maksutavatJaKayttajat[i].maksutapa.tunniste"
                      [disabled]="maksutapa.kirjaustenLuontityyppi().value()?.tunniste !== 'g'"
                    >
                    </mat-checkbox>
                  </td>
                }
                <!-- <td *ngIf="isOmallaRahallaColumnVisible">
              <mat-form-field *ngIf="maksutapa.get('kirjaustenLuontityyppi').value?.tunniste === 'g'" style="width: 180px;">
                <mat-select formControlName="omallaRahallaUid" placeholder="Valitse käyttäjä">
                  <mat-option [value]="null">Kaikkien käyttäjien käytössä</mat-option>
                  <mat-option *ngFor="let kayttaja of kaikkiKayttajatObservable | async" [value]="kayttaja.avain">
                    {{ kayttaja.etunimi + ' ' + kayttaja.sukunimi }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </td> -->
                <!-- <td>
            <mat-form-field>
              <input decimalNumberField matInput floatLabel="never" formControlName="tunniste" placeholder="Tunniste" numberOfDecimals="0">
            </mat-form-field>
          </td> -->
                <td>
                  <mat-form-field style="width: 175px">
                    <input type="text" tahtiOhjeeseen [formField]="maksutapa.nimi" matInput autocomplete="kirjanpitoaineistoarkki" placeholder="Nimi" data-lpignore="true" />
                    @if (naytaVirhe(maksutapa.nimi, 'required')) {
                      <mat-error> Nimi puuttuu </mat-error>
                    }
                  </mat-form-field>
                </td>
                <td style="display: flex">
                  <mat-form-field style="width: 200px">
                    <mat-select [formField]="maksutapa.kirjaustenLuontityyppi" [compareWith]="compareLuontityypit" placeholder="Luontityyppi">
                      @for (kirjaustenLuontityyppi of kirjaustenLuontityypit; track kirjaustenLuontityyppi) {
                        <!-- Poistunut tyyppi pidetään vaihtoehtona vain riveillä, joilla se on jo, jotta tallennettu arvo ei näy tyhjänä -->
                        @if (!kirjaustenLuontityyppi.poistunutKaytosta || compareLuontityypit(kirjaustenLuontityyppi, maksutapa.kirjaustenLuontityyppi().value())) {
                          <mat-option [value]="kirjaustenLuontityyppi" [disabled]="kirjaustenLuontityyppi.poistunutKaytosta || (kirjaustenLuontityyppi.alitunniste === 'holvi' && isHolviApiSelectionDisabled) || (kirjaustenLuontityyppi.vainLuottokirjanpitajalle && !kirjanpitajaOnLuotto())">
                            {{ kirjaustenLuontityyppi.nimi }}
                          </mat-option>
                        }
                      }
                    </mat-select>
                    @if (naytaVirhe(maksutapa.kirjaustenLuontityyppi, 'required')) {
                      <mat-error> Kirjausten luontityyppi puuttuu </mat-error>
                    }
                  </mat-form-field>
                  @if (kirjanpitajaOnDevaajaTaiTukiObservable | async) {
                    @if (maksutapa.kirjaustenLuontityyppi().value()?.tunniste === 's' && (maksutavatJaKayttajat[i].maksutapa.sahkoisenTiliotteenAlatyyppi === 'aiia' || maksutavatJaKayttajat[i].maksutapa.sahkoisenTiliotteenAlatyyppi === 'enable banking')) {
                      @if (!maksutavatJaKayttajat[i].maksutapa.scheduledProviderChange) {
                        <app-icon-button (click)="startProviderChange(i)" matTooltip="Vaihda sähköisen tiliotteen palveluntarjoaja">
                          <mat-icon>change_circle</mat-icon>
                        </app-icon-button>
                      } @else {
                        <app-icon-button
                          (click)="cancelScheduledChange(i)"
                          matTooltip="Sähköisen tiliotteen palveluntarjoaja vaihtuu {{ maksutavatJaKayttajat[i].maksutapa.scheduledProviderChange.voimassaAlkaen | lnumberpvml: 'fi' }}: {{ maksutavatJaKayttajat[i].maksutapa.sahkoisenTiliotteenAlatyyppi }} → {{ maksutavatJaKayttajat[i].maksutapa.scheduledProviderChange.uusiAlatyyppi }}. Klikkaa peruuttaaksesi vaihdon."
                        >
                          <mat-icon class="light-blue-text">priority_high</mat-icon>
                        </app-icon-button>
                      }
                    }
                  }
                </td>
                <td>
                  <mat-form-field [style.visibility]="maksutapa.kirjaustenLuontityyppi().value()?.tunniste === 's' ? 'visible' : 'hidden'" style="width: 170px">
                    <input type="text" tahtiOhjeeseen [formField]="maksutapa.sahkoisenTiliotteenTunniste" matInput [matAutocomplete]="auto" autocomplete="kirjanpitoaineistoarkki" placeholder="Tilinumero" data-lpignore="true" />
                    <mat-autocomplete #auto="matAutocomplete" [panelWidth]="285">
                      @for (ibanJaPankki of asiakkaanIbanitJaPankitObservable | async; track ibanJaPankki) {
                        <mat-option [value]="ibanJaPankki.iban">
                          {{ ibanJaPankki.iban }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                    @if (naytaVirhe(maksutapa.sahkoisenTiliotteenTunniste, 'required')) {
                      <mat-error> Tilinumero puuttuu </mat-error>
                    }
                    @if (naytaVirhe(maksutapa.sahkoisenTiliotteenTunniste, 'invalidiban')) {
                      <mat-error> Tilinumero ei ole pätevä IBAN </mat-error>
                    }
                    @if (naytaVirhe(maksutapa.sahkoisenTiliotteenTunniste, 'invalidbic')) {
                      <mat-error> Tämän pankin ({{ annaPankinNimi(maksutapa.sahkoisenTiliotteenTunniste().value()) }}) tiliä ei voi käyttää valitulla sähköisen tiliotteen kanavalla </mat-error>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field style="width: 100px">
                    <input type="text" tahtiOhjeeseen [formField]="maksutapa.oletusVastatili" [matAutocomplete]="tiliAuto" matInput autocomplete="kirjanpitoaineistoarkki" placeholder="Vastatili" data-lpignore="true" />
                    @if (naytaVirhe(maksutapa.oletusVastatili, 'required')) {
                      <mat-error> Vastakirjauksen tili puuttuu </mat-error>
                    }
                    @if (naytaVirhe(maksutapa.oletusVastatili, 'notkirjanpitotili')) {
                      <mat-error> Lisää voimassa oleva kirjanpitotili </mat-error>
                    }
                    @if (naytaVirhe(maksutapa.oletusVastatili, 'vastatiliKaytossa')) {
                      <mat-error> Sama vastatili on jo käytössä toisessa maksutavassa </mat-error>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field [style.visibility]="!maksutapa.tilitapahtumatSynkronoidaanAlkaen().disabled() ? 'visible' : 'hidden'" style="width: 100px">
                    <input type="text" [matDatepicker]="synkronoidaanAlkaenPicker" [formField]="maksutapa.tilitapahtumatSynkronoidaanAlkaen" matInput data-lpignore="true" />
                    @if (naytaVirhe(maksutapa.tilitapahtumatSynkronoidaanAlkaen, 'required')) {
                      <mat-error> Tilitapahtumien synkronoinnin alku puuttuu </mat-error>
                    }
                    <mat-datepicker-toggle matSuffix [for]="synkronoidaanAlkaenPicker"></mat-datepicker-toggle>
                    <mat-datepicker #synkronoidaanAlkaenPicker startView="month"></mat-datepicker>
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field [style.visibility]="!maksutapa.tilitapahtumatSynkronoidaanLoppuen().disabled() ? 'visible' : 'hidden'" style="width: 100px">
                    <input type="text" [matDatepicker]="synkronoidaanLoppuenPicker" [formField]="maksutapa.tilitapahtumatSynkronoidaanLoppuen" matInput data-lpignore="true" />
                    <!-- <mat-error *ngIf="naytaVirhe(maksutapa.synkronoidaanLoppuenPicker, 'required')">
              Tilitapahtumien synkronoinnin loppu puuttuu
            </mat-error> -->
                    <mat-datepicker-toggle matSuffix [for]="synkronoidaanLoppuenPicker"></mat-datepicker-toggle>
                    <mat-datepicker #synkronoidaanLoppuenPicker startView="month"></mat-datepicker>
                  </mat-form-field>
                </td>
                <td style="vertical-align: middle; padding-left: 20px; padding-right: 30px">
                  @if (maksutavatJaKayttajat[i].kayttajat.length > 1) {
                    <div style="height: 16px"></div>
                  }
                  @for (kayttaja of maksutavatJaKayttajat[i].kayttajat; track kayttaja) {
                    <div style="white-space: nowrap">{{ kayttaja.sukunimi }} {{ kayttaja.etunimi }}</div>
                  }
                </td>
                <td style="text-align: center; padding-top: 20px">
                  <mat-checkbox [formField]="maksutapa.aktiivinen"></mat-checkbox>
                </td>
                <td style="text-align: center; padding-top: 20px">
                  <mat-checkbox [checked]="maksutavatJaKayttajat[i].onkoValtuutus" [disabled]="true"></mat-checkbox>
                </td>
                @if (kirjanpitajaOnLuottoObservable | async) {
                  <td>
                    <app-icon-button (click)="showMaksutapaHistory(i)" type="button" matTooltip="Näytä historia" style="padding-top: 20px">
                      <mat-icon>history</mat-icon>
                    </app-icon-button>
                  </td>
                }
                <!-- <td style="text-align: center;">
        <mat-radio-button [value]="i"></mat-radio-button>
      </td> -->
                <!-- <td style="text-align: center;">
      <button mat-icon-button (click)="maksutapaYlos(i)" type="button">
        <mat-icon>arrow_drop_up</mat-icon>
      </button>
      <button mat-icon-button (click)="maksutapaAlas(i)" type="button">
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </td> -->
                <td class="dark-gray-text" style="padding-left: 10px">
                  @if ((kirjanpitajaOnDevaajaTaiTukiObservable | async) && maksutavatJaKayttajat[i].maksutapa.sahkoisenTiliotteenTunniste) {
                    <app-icon-button (click)="avaaPoistaTilitapahtumatDialog(i)" actionId="Poista maksutapa" [actionContext]="[maksutavatJaKayttajat[i].maksutapa.tunniste, maksutavatJaKayttajat[i].maksutapa.sahkoisenTiliotteenTunniste]" matTooltip="Poista kaikki tilitapahtumat ja kirjaukset (IT)" style="color: #f44336">
                      <mat-icon>delete_forever</mat-icon>
                    </app-icon-button>
                  }
                </td>
              </tr>
            }
          </table>
          <mat-autocomplete #tiliAuto="matAutocomplete" panelWidth="300px">
            @for (tili of suodatetutKirjanpitotilitObservable | async; track tili) {
              <mat-option [value]="tili.numero"> {{ tili?.numero }} {{ tili?.nimi }} </mat-option>
            }
          </mat-autocomplete>
          @if (commonError()) {
            <div class="error-text">
              {{ commonError() }}
            </div>
          }
          <div style="margin-left: 10px; padding-top: 2em; display: flex; justify-content: space-between; flex-flow: row wrap">
            <div></div>
            <app-secondary-button (click)="save()" actionId="Tallenna maksutavat" [actionContext]="[$any(lomake().value())]" additionalClass="mat-elevation-z4" styles="margin: 0 2em;"> Tallenna </app-secondary-button>
          </div>
        </form>
      }
    </div>
    @if (naytaMaksutilitObservable | async) {
      <div style="margin-left: 10px; margin-top: 100px; display: flex; justify-content: space-between; flex-flow: row wrap; align-items: center">
        <h2 style="margin: 0">Maksutilit Lemonaidissa</h2>
        <!-- <button mat-button (click)="lisaaMaksuConfig()" type="button" class="secondarybutton mat-elevation-z4" style="height: 40px; padding-left: 8px; margin: 0 2em;">
    <mat-icon>add</mat-icon>
    Lisää maksutili
  </button> -->
      </div>
      @if (asiakkaanApixTiedotObservable | async; as asiakkaanApixTiedot) {
        @if (asiakkaanApixTiedot.paymentReceiveIsActive) {
          <div style="margin-left: 10px">
            @if (!asiakkaanApixTiedot.paymentIsActive) {
              <div style="margin: 20px 0px 0px 20px">HUOM! Maksuominaisuus ei ole käytössä. Alla olevat maksutilit eivät tule käyttöön ennen kuin maksuominaisuus on kytketty päälle.</div>
            }
          </div>
          <div>
            <mat-slide-toggle #maksuominaisuusToggle style="font-size: 12px; padding: 25px" (change)="kytkeMaksuominaisuus($event, maksuominaisuusToggle)" [checked]="asiakkaanApixTiedot.paymentIsActive">
              Maksuominaisuus on <b>{{ asiakkaanApixTiedot.paymentIsActive ? 'päällä' : 'pois päältä' }}</b>
            </mat-slide-toggle>
          </div>
        } @else {
          <div style="margin-left: 10px">
            <div style="margin: 20px">HUOM! Asiakas ei ole ottanut ostolaskujen vastaanottoa käyttöön Lemonaidissa. Maksuominaisuutta ei saa päälle, ennen kun asiakas on ottanut ostolaskujen vastaanottopalvelun käyttöön.</div>
          </div>
        }
      }
      <!-- <div *ngIf="kirjanpitajaOnDevaajaObservable | async" style="padding: 10px; margin-bottom: 20px; margin-left: 20px; max-width: 600px; position: relative;" class="mat-elevation-z2">
<span style="font-size: 10px; position: absolute; top: 3px; right: 5px;" class="light-gray-text">(Vain devaajat)</span>
<h3 style="margin: 0;">Urit</h3>
<div style="padding-top: 1em; padding-left: 1em; padding-right: 1em;">Maksutavat (Lemonator): <a [href]="maksutavatEncodedUriObservable | async" target="_BLANK">{{maksutavatUriObservable | async}}</a></div>
<div style="padding-top: 0em; padding-left: 1em; padding-right: 1em;">Maksutavat (Lemonaid eu asiakkaassa): <a [href]="maksutavatLemonaidCustomersEncodedUriObservable | async" target="_BLANK">{{maksutavatLemonaidCustomersUriObservable | async}}</a></div>
<div style="padding-top: .5em; padding-left: 1em; padding-right: 1em;">Maksutavat (Lemonaid usa realtime db, käyttäjittäin):</div>
<div *ngFor="let kayttaja of maksutavatLemonaidRealtimeDbUriObservable | async" style="padding-left: 1em;">
  <div style="padding-top: 0em; padding-left: 1em; padding-right: 1em;">{{kayttaja.kayttaja}}: <a [href]="kayttaja.encodedUri" target="_BLANK">{{kayttaja.uri}}</a></div>
</div>
</div> -->
      <div style="margin-top: 10px; margin-left: 10px">
        <!-- <mat-progress-bar *ngIf="lataaMaksutapoja" mode="indeterminate"></mat-progress-bar> -->
        @if (!lataaMaksutapoja) {
          <form (ngSubmit)="saveMaksuConfigs()" novalidate>
            <div style="max-width: 975px">
              <div style="margin: 20px" class="dark-gray-text">
                Lemonaidin maksutilit näkyvät kaikilla käyttäjillä, joilla on "Ostolaskujen maksaja" rooli. Näiltä tileillä asiakas voi maksaa laskuja Lemonaidissa.
                @if (asiakkaanOstolaskujenMaksajaRoolinKayttajatObservable | async; as asiakkaanOstolaskujenMaksajaRoolinKayttajat) {
                  @if (asiakkaanOstolaskujenMaksajaRoolinKayttajat?.length > 0) {
                    <div style="margin-left: 20px; margin-top: 5px">
                      <div>"Ostolaskujen maksaja" rooli löytyy seuraavilta käyttäjiltä:</div>
                      <ul>
                        @for (kayttaja of asiakkaanOstolaskujenMaksajaRoolinKayttajat; track kayttaja) {
                          <li>{{ kayttaja.etunimi }} {{ kayttaja.sukunimi }}</li>
                        }
                      </ul>
                    </div>
                  } @else {
                    <div style="margin-left: 20px; margin-top: 5px">"Ostolaskujen maksaja" roolia ei löydy yhdeltäkään aktiiviselta käyttäjältä. Lisää rooli kohdasta Lemonaid -> Käyttäjät.</div>
                  }
                }
              </div>
              <div class="light-blue-text header">Maksutilit</div>
              <div class="content">
                <div style="max-width: 975px">
                  @for (config of maksuConfigLomake.configs; track config; let i = $index) {
                    <div>
                      <mat-form-field style="max-width: 175px; margin-right: 10px">
                        <input #debtorIdentifier="matInput" tahtiOhjeeseen [formField]="config.debtorIdentifier" placeholder="Maksatustunnus" matInput data-lpignore="true" />
                        @if (naytaVirhe(config.debtorIdentifier, 'required')) {
                          <mat-error> Maksatustunnus puuttuu </mat-error>
                        }
                        <mat-icon style="padding-top: 10px" matSuffix matTooltip="Maksatustunnus on yleensä y-tunnus etunollineen ilman väliviivaa (paitsi Dansken tileillä - niillä etunollaa ei ole)">info_outline</mat-icon>
                      </mat-form-field>
                      <mat-form-field style="max-width: 175px; margin-right: 10px">
                        <input #iban="matInput" tahtiOhjeeseen [formField]="config.iban" [matAutocomplete]="autoIban" placeholder="Tilinumero" matInput data-lpignore="true" />
                        <mat-autocomplete #autoIban="matAutocomplete" [panelWidth]="285">
                          @for (ibanJaPankki of asiakkaanIbanitJaPankitObservable | async; track ibanJaPankki) {
                            <mat-option [value]="ibanJaPankki.iban">
                              {{ ibanJaPankki.iban }}
                            </mat-option>
                          }
                        </mat-autocomplete>
                        @if (naytaVirhe(config.iban, 'required')) {
                          <mat-error> Tilinumero puuttuu </mat-error>
                        }
                        @if (naytaVirhe(config.iban, 'invalidiban')) {
                          <mat-error> Tilinumero ei ole pätevä IBAN </mat-error>
                        }
                      </mat-form-field>
                      <mat-form-field style="width: 175px; margin-right: 10px">
                        <mat-select [formField]="config.bank" placeholder="Pankki">
                          @for (pankki of maksamisenPankit; track pankki) {
                            <mat-option [value]="pankki.bank">
                              {{ pankki.nimi }}
                            </mat-option>
                          }
                        </mat-select>
                        @if (naytaVirhe(config.bank, 'required')) {
                          <mat-error> Pankki puuttuu </mat-error>
                        }
                      </mat-form-field>
                      <mat-form-field style="max-width: 125px; margin-right: 10px">
                        <input #alkaa="matInput" [matDatepicker]="perusteAlkaaPicker" tahtiOhjeeseen [formField]="config.start" placeholder="Alkaa" matInput data-lpignore="true" />
                        <mat-datepicker-toggle matSuffix [for]="perusteAlkaaPicker"></mat-datepicker-toggle>
                        <mat-datepicker #perusteAlkaaPicker></mat-datepicker>
                        @if (naytaVirhe(config.start, 'required')) {
                          <mat-error> Alkamispäivä puuttuu </mat-error>
                        }
                        @if (naytaVirhe(config.start, 'loppuEnnenAlkua')) {
                          <mat-error> Pitää alkaa ennen loppua </mat-error>
                        }
                      </mat-form-field>
                      <mat-form-field style="max-width: 125px; margin-left: 10px; margin-right: 10px">
                        <input #loppuu="matInput" type="text" [matDatepicker]="perusteLoppuuPicker" [formField]="config.end" placeholder="Loppuu" matInput data-lpignore="true" />
                        <mat-datepicker-toggle matSuffix [for]="perusteLoppuuPicker"></mat-datepicker-toggle>
                        @if (naytaVirhe(config.end, 'loppuEnnenAlkua')) {
                          <mat-error> Pitää loppua alun jälkeen </mat-error>
                        }
                        <mat-datepicker #perusteLoppuuPicker></mat-datepicker>
                      </mat-form-field>
                      @if (maksatustunnusEhdotus && !debtorIdentifier.value) {
                        <div class="maksatustunnus-ehdotus lemon-mat-elevation-z4" (mousedown)="asetaMaksatustunnusEhdotus(config, $event)"><mat-icon class="green-text">check_circle</mat-icon> Ehdotus: {{ maksatustunnusEhdotus }}</div>
                      }
                    </div>
                  }
                </div>
                @if (commonErrorPaymentConfigs) {
                  <div class="error-text">
                    {{ commonErrorPaymentConfigs }}
                  </div>
                }
                <div style="padding-top: 10px; padding-bottom: 1.25em">
                  <app-secondary-button (click)="lisaaMaksuConfig()" actionId="Avattu muokkausnäkymä: Lisää maksutili rivi" additionalClass="mat-elevation-z4" matIcon="add"> Lisää maksutili </app-secondary-button>
                </div>
              </div>
              <div style="margin: 20px" class="dark-gray-text">
                Lemonaidin maksujen hyväksyntätyökalut näkyvät kaikilla käyttäjillä, joilla on "Ostolaskujen hyväksyjä" rooli.
                @if (asiakkaanOstolaskujenHyvaksyjaRoolinKayttajatObservable | async; as asiakkaanOstolaskujenHyvaksyjaRoolinKayttajat) {
                  @if (asiakkaanOstolaskujenHyvaksyjaRoolinKayttajat?.length > 0) {
                    <div style="margin-left: 20px; margin-top: 5px">
                      <div>"Ostolaskujen hyväksyjä" rooli löytyy seuraavilta käyttäjiltä:</div>
                      <ul>
                        @for (kayttaja of asiakkaanOstolaskujenHyvaksyjaRoolinKayttajat; track kayttaja) {
                          <li>{{ kayttaja.etunimi }} {{ kayttaja.sukunimi }}</li>
                        }
                      </ul>
                    </div>
                  } @else {
                    <div style="margin-left: 20px; margin-top: 5px">
                      "Ostolaskujen hyväksyjä" roolia ei löydy yhdeltäkään aktiiviselta käyttäjältä.
                      <span style="font-weight: bold">Ostolaskujen hyväksyntä ei siis ole päällä.</span>
                      Lisää rooli kohdasta Lemonaid -> Käyttäjät.
                    </div>
                  }
                }
              </div>
              <!-- <div class="light-blue-text otsikko">Yhteystiedot</div> -->
              <mat-form-field style="width: 200px">
                <mat-label>Hyväksyjien lukumäärä</mat-label>
                <input #hyvaksyjienLukumaaraInput="matInput" decimalNumberField type="text" [formField]="maksuConfigLomake.hyvaksyjienLukumaara" matInput [numberOfDecimals]="0" />
                @if (naytaVirhe(maksuConfigLomake.hyvaksyjienLukumaara, 'required')) {
                  <mat-error> Lukumäärä puuttuu </mat-error>
                }
                @if (naytaVirhe(maksuConfigLomake.hyvaksyjienLukumaara, 'min')) {
                  <mat-error> Lukumäärän minimi on 1 </mat-error>
                }
              </mat-form-field>
            </div>
            <div style="margin-left: 10px; padding-top: 2em; display: flex; justify-content: space-between; flex-flow: row wrap">
              <div></div>
              <app-secondary-button (click)="saveMaksuConfigs()" actionId="Tallenna maksutilit" [actionContext]="[$any(maksuConfigLomake().value())]" additionalClass="mat-elevation-z4" styles="margin: 0 2em;"> Tallenna </app-secondary-button>
            </div>
          </form>
        }
      </div>
    }
    <!-- <input style="visibility:hidden; height: 1px;" (change)="fileChanged($event)" type="file" accept="image/*" #fileInput /> -->
  }
</div>
